class Config {
  constructor() {
    window._portalConfig = window._portalConfig || {}
  }

  values() {
    return window._portalConfig
  }

  configure = values => {
    window._portalConfig = values
  }

  set = (key, value) => {
    this.values()[key] = value
  }

  get = key => {
    return this.values()[key]
  }

  require = key => {
    const value = this.get(key)
    if (!(key in this.values()) || value === undefined) throw(`Missing configuration: ${key}`)
    return value
  }
}

export default new Config()
